module.exports = __webpack_public_path__ + "img/41_cznRQCj05NM2pBGA6wrwhkwU.60fee614.png";